import React from 'react';
import { Typography, Container, Grid, Paper } from "@mui/material";
import 'react-image-gallery/styles/css/image-gallery.css';
import IMAGES from './tm_list';
import Gallery from 'react-grid-gallery';


function TM() {
    return (
        <>
            <Container disableGutters={false} maxWidth='xl' >
                <Grid container spacing={0} justify='center'>
                    <Grid item md={2}></Grid>
                    <Grid item xs={12} md={8}>
                        <Paper elevation={5} sx={{ p: 4, height: '102%' }}>
                            <Typography variant="h5" sx={{ textAlign: 'center' }}>Thinmatrix Py</Typography>
                            <Typography variant="body2" sx={{ textAlign: 'center' }}><a style={{ color: 'grey' }} href="https://github.com/vinhub100/thinmatrix_py" target='_blank' rel="noopener noreferrer">vinhub100/thinmatrix_py</a></Typography>
                            <hr />
                            <Typography variant="body2">Python 3 implimentation of thinmatrix opengl tutorial 👍</Typography>
                            <Typography variant="body2"> Link to <a style={{ color: 'green' }} href="https://www.youtube.com/c/ThinMatrix" target='_blank' rel="noopener noreferrer">thinmatrix - YouTube Channel</a></Typography>
                            <Typography variant="body2"> Link to <a style={{ color: 'green' }} href="https://www.youtube.com/playlist?list=PLRIWtICgwaX0u7Rf9zkZhLoLuZVfUksDP" target='_blank' rel="noopener noreferrer">thinmatrix - OpenGL Tutorial Playlist</a></Typography>
                            <br />
                            <Typography variant="h6">Screenshots:</Typography>
                            {/* <ImageGallery items={images} lazyLoad={true} /> */}
                            <div sx={{ p: 1 }}>
                                <Gallery images={IMAGES} rowHeight={150} />
                            </div>
                        </Paper>

                    </Grid>

                </Grid>
            </Container>

        </>
    )
}

export default TM;

